module.exports = __webpack_public_path__ + "static/media/suiteHeader.3999b768.png";